<h2 mat-dialog-title>Download Layer</h2>
<mat-dialog-content class="mat-typography">

  <form
    [formGroup]="form"
  >
<section class="grid grid--row gap--md">

  <mat-form-field>
    <mat-label>Layer Format</mat-label>
    <mat-select formControlName="layerFormat">
      <mat-option value="geoJSON">GeoJSON</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>SRID</mat-label>
    <mat-select formControlName="srid">
      <mat-option value="4326">EPSG:4326</mat-option>
      <mat-option value="3857">EPSG:3857</mat-option>
      <mat-option value="28355">EPSG:28355</mat-option>
    </mat-select>
  </mat-form-field>

</section>


  </form>

</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button class="button button--muted button--xs">Cancel</button>
  <button class="button button--green-fill button--xs" (click)="download()">Download Layer</button>
</mat-dialog-actions>
